import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

const JobCard = () => {
	const block = document.querySelectorAll(".job-card");
	if (!block) {
		return;
	}
  gsap.registerPlugin(ScrollToPlugin);

	block.forEach((el) => {
		const id = el.getAttribute("id");
		const hashFromUrl = window.location.hash;
    const header = document.querySelector(".header");
    const head = el.querySelector(".job-card__head");
    const copy = el.querySelector(".job-card__copy");
    const copyLabel = copy.querySelector(".job-card__copy-label");
    const copyLabelText = copyLabel.innerHTML;
		
		if (hashFromUrl && hashFromUrl === `#${id}`) {
      gsap.to(window, {
        duration: 0.5,
        delay: 0.2,
        scrollTo: {
          y: el,
          offsetY: header.offsetHeight + 40
        }
      });
      head.click();
		}

		copy.addEventListener("click", () => {
			navigator.clipboard.writeText(`${window.location.origin}${window.location.pathname}#${id}`);
			
			copy.classList.add("is-copied");
			copyLabel.textContent = copy.getAttribute("data-label");
			
			setTimeout(() => {
				copy.classList.remove("is-copied");
				copyLabel.innerHTML = copyLabelText;
			}, 2000);
		});
	});
};

export default JobCard;
